;
(function(w) {
	class globalFunctions {
		//Set cookies 
		getsec(str) {
			var str1 = str.substring(1, str.length) * 1;
			var str2 = str.substring(0, 1);
			if (str2 == "s") {
				return str1 * 1000;
			} else if (str2 == "h") {
				return str1 * 60 * 60 * 1000;
			} else if (str2 == "d") {
				return str1 * 24 * 60 * 60 * 1000;
			}
		}

		setCookie(name, value, time) {
			var strsec = globalFunction.getsec(time);
			var exp = new Date();
			exp.setTime(exp.getTime() + strsec * 1);
			document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
		}


		//Get cookies 
		getCookie(name) {
			var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

			if (arr = document.cookie.match(reg))
				return unescape(arr[2]);
			else
				return null;
		}

		//Remove cookies 
		delCookie(name) {
			var exp = new Date();
			exp.setTime(exp.getTime() - 1);
			var cval = globalFunction.getCookie(name);
			if (cval != null)
				document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
		}
		//对时间进行补零操作
		checkTimes(i) {
			if (i < 10) {
				i = "0" + i;
			} else {
				i = (i + "")
			}
			return i;
		}

		//获取日时分秒

		getDiffTime(time) {
			let day = parseInt(time / 60 / 60 / 24),
				hour = parseInt(time / 60 / 60) - day * 24,
				minute = parseInt(time / 60) - parseInt(time / 60 / 60) * 60,
				second = parseInt(time) - parseInt(time / 60) * 60;

			day = globalFunction.checkTimes(day);
			hour = globalFunction.checkTimes(hour);
			minute = globalFunction.checkTimes(minute);
			second = globalFunction.checkTimes(second);

			return day + hour + minute + second;

		};
		//获取美国日期即年月日
		getDateStringByDateAndZone(time_zone, date) {
			if (null == time_zone || '' === time_zone) {
				throw '时区信息不能为空';
			}
			date = date || new Date();
			return date.toLocaleDateString('en-US', {
				timeZone: time_zone,
				hour24: true
			});
		};
		//获取美国时间即时分秒

		getTimeStringByDateAndZone(time_zone, date) {
			if (null == time_zone || '' === time_zone) {
				throw '时区信息不能为空';
			}
			date = date || new Date();
			return date.toLocaleTimeString('en-US', {
				timeZone: time_zone,
				hour24: true
			});
		};
      
      windowOpen(clickTag, url){
      	window.open(url)
      };
      
     changeCmIn(sizeCmIn) {
        const cm = 2.54;
        let sizeCm = '';
        if(sizeCmIn.indexOf('-') != -1){
          let cm1 = (parseFloat(sizeCmIn.split('-')[0])*cm).toFixed(1),
              cm2 = (parseFloat(sizeCmIn.split('-')[1])*cm).toFixed(1);

          sizeCm = cm1+'-'+cm2;
        }else{
          
          sizeCm = (parseFloat(sizeCmIn)*cm).toFixed(1);
          
        }
       return sizeCm;
       
      }

	}

	const globalFunction = new globalFunctions();
	w.prototype.globalFunction = globalFunction;

})(Window);
